export const STORIES_BASE_PATH = '/stories-of-us';
export const ASSET_PREFIX = 'https://www.ancestrycdn.com/america-250';

export const storiesOverviewRoutes = [`${STORIES_BASE_PATH}/record-gallery`, `${STORIES_BASE_PATH}/250-stories`];
